module.exports = __webpack_public_path__ + "static/media/checklist-welcome-bg.56ff5829.svg";